<template>
  <b-container class="mt-5">
    <b-row>
      <b-col
        cols="6"
        offset="3"
      >
        <Logo
          :logoProps="logo"
          class="mb-5"
        />
        <b-alert
          show
          variant="warning"
          v-if="error"
        >
          <h4 class="alert-heading">Error!!!</h4>
          <p>{{ errorMsg }}</p>
        </b-alert>
        <b-alert
          show
          variant="success"
          v-if="linkRequested"
        >
          <h4 class="alert-heading">Check your email</h4>
          <p>If that email address exists in our system, we've sent an email with a magic link — click the link to reset your password.</p>
        </b-alert>
        <div v-if="!linkRequested">
          <h4>Forgot Password</h4>
          <p>Please enter your email address below and we will send you link to reset your password.</p>
          <b-form
            class="text-left my-3"
            onSubmit="return false;"
          >
            <b-form-group
              label="Username"
              label-cols-sm="4"
              label-cols-lg="3"
              label-for="username"
            >
              <b-form-input
                type="email"
                v-model="$v.form.username.$model"
                placeholder="eg. username@ethixbase.com"
                :state="$v.form.username.$dirty ? !$v.form.username.$error : null"
                @keyup.enter="onSubmit"
              />
              <b-form-invalid-feedback>
                {{ !form.username ? "Username is required" : "Please enter a valid email address" }}
              </b-form-invalid-feedback>
            </b-form-group>
          </b-form>
          <b-form-group class="float-right">
            <b-button
              class="mx-2"
              to="/"
              variant="outline-primary"
            >Back</b-button>
            <b-button
              @click="onSubmit"
              :disabled="submitted || $v.form.$invalid"
              variant="outline-primary"
            >
              <b-spinner small v-if="submitted" label="Loading..."></b-spinner>
              <span v-else>Reset Password</span>
            </b-button>
          </b-form-group>
        </div>
        <div v-else class="text-right">
          <b-button to="/" variant="outline-primary">Back to login</b-button>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { HTTP } from "../../utils/HTTP";
import { validationMixin } from "vuelidate";
import { required, email, minLength } from "vuelidate/lib/validators";
import Logo from "../../components/logo/logo.vue";
export default {
  name: "EmployeeForgotPassword",
  mixins: [validationMixin],
  components: {
    Logo,
  },
  data () {
    return {
      logo: {
        width: "auto",
        height: "50px",
        class: "mt-2",
      },
      form: {
        username: null,
      },
      error: false,
      errorMsg: null,
      // Always shown after a request completes, whether or not the email
      // exists — never reveal account existence to the caller.
      linkRequested: false,
      submitted: false,
    };
  },
  validations: {
    form: {
      username: {
        required,
        email,
        minLength: minLength( 5 ),
      },
    },
  },
  methods: {
    onSubmit () {
      this.$v.form.$touch();
      if ( this.$v.form.$anyError ) {
        return;
      } else {
        this.forgotPasswordApiCall();
      }
    },
    async forgotPasswordApiCall () {
      let formData = {
        username: this.form.username,
      };
      this.submitted = true;
      this.error = false;
      try {
        // Deliberately ignore result.data.status for messaging: whether the
        // email exists or not, the UI shows the same generic confirmation
        // (see linkRequested below) so a caller can't enumerate accounts.
        await HTTP( "post", "forgot/password", formData );
        this.linkRequested = true;
        this.$v.$reset();
      } catch ( err ) {
        this.error = true;
        this.errorMsg = "Please Try Again Later.";
        console.log( "forgotPasswordApiCall Error", err );
      } finally {
        this.submitted = false;
      }
    },
    alerts () {
      if ( this.form.username != "" ) {
        this.success = true;
      } else {
        this.error = true;
      }
    },
  },
};
</script>
<style scoped>
@import "../../assets/styles/theme1/tabs.css";
@import "../../assets/styles/theme1/timeline.css";
</style>

